import { Box, Flex, Text, Heading, Button, DropdownMenu, Card, Switch, Badge, Dialog, TextField, VisuallyHidden } from '@radix-ui/themes';
import { useSelector, useDispatch } from 'react-redux';
import { useState, useEffect } from 'react';
import { subscriptionService } from '../../services/subscriptionService';
import CourseView from '../common/CourseView';
import { RocketIcon, PersonIcon, CheckIcon, Cross2Icon, ExclamationTriangleIcon, Pencil1Icon } from '@radix-ui/react-icons';
import UserAvatar from '../common/UserAvatar';
import StudentCourseSetup from './StudentCourseSetup';
import { updateStudentSubscriptions } from '../../redux/slices/studentAccountSlice';

const StudentCourses = () => {
    const user = useSelector((state) => state.account.userDetails);
    const student = useSelector((state) => state.studentAccount.details);
    const school = useSelector((state) => state.studentAccount.school);
    const subscriptions = useSelector((state) => state.studentAccount.subscriptions);
    // const [subscriptions, setSubscriptions] = useState([]);
    const [availableSubjectCourses, setAvailableSubjectCourses] = useState({});
    const [subjects, setSubjects] = useState([]);
    const [availableSubjects, setAvailableSubjects] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [editing, setEditing] = useState(null);
    const [openSetupDialog, setOpenSetupDialog] = useState(false);

    const dispatch = useDispatch();

    console.log('subscriptions', subscriptions);

    useEffect(() => {
        // const fetchSubscriptions = async () => {
        //     try {
        //         const fetchedSubscriptions = await subscriptionService.getSubscriptions();
        //         setSubscriptions(fetchedSubscriptions);
        //     } catch (error) {
        //         console.error('Error fetching subscriptions:', error);
        //     } finally {
        //         setIsLoading(false);
        //     }
        // };

        // fetchSubscriptions();
        getAvailableSubjects();
    }, []);

    useEffect(() => {
        console.log('availableSubjectCourses', availableSubjectCourses);
    }, [availableSubjectCourses]);

    const getAvailableSubjects = async () => {
        try {
            const subjects = await subscriptionService.getSubjectsByLevel();
            setSubjects(subjects);
            setAvailableSubjects(filterAvailableSubjects(subjects));
            // setAvailableSubjects(availableSubjects);
        } catch (error) {
            console.error('Error fetching available subjects:', error);
        }
    }

    const filterAvailableSubjects = (subjects) => {
        return subjects.filter(subject =>
            !subscriptions.some(subscription => subscription.subject_id === subject.id)
        );
    }

    useEffect(() => {
        setAvailableSubjects(filterAvailableSubjects(subjects));
    }, [subscriptions]);

    const getAvailableCourses = async (subjectId) => {
        try {
            const courses = await subscriptionService.getAvailableCourses({
                subjectId: subjectId,
                levelId: student.current_level,
                schoolId: school?.id || null
            });
            return courses;
        } catch (error) {
            console.error('Error fetching available courses:', error);
        }
    };

    const handleSelectSubject = async (subjectId) => {
        setEditing(subjectId);
        try {
            const availableCourses = await getAvailableCourses({ subjectId });
            console.log('availableCourses', availableCourses);
            setAvailableSubjectCourses({ subscriptionId: null, courses: availableCourses });
        } catch (error) {
            console.error('Error updating subscription:', error);
        }
    };

    const handleChangeSubscription = async (subscription) => {
        const courses = { subscription_id: subscription.id }
        try {
            setIsLoading(true)
            const availableCourses = await getAvailableCourses(subscription.course.subject_id);
            setAvailableSubjectCourses({ subscriptionId: subscription.id, courses: availableCourses });
        } catch (error) {
            console.error('Error changing subscription:', error);
        } finally {
            setIsLoading(false)
        }
    }

    const handleRemoveSubscription = async (subscriptionId) => {
        try {
            await subscriptionService.removeSubscription(subscriptionId);
            setSubscriptions(prev => prev.filter(sub => sub.id !== subscriptionId));
        } catch (error) {
            console.error('Error removing subscription:', error);
        }
    };

    const handleSubscribe = async (course) => {
        const selectedSubscription = subscriptions.find(sub => sub.course.id == course.id);
        console.log('selectedSubscription', selectedSubscription);
        let newSubscription = null;
        if (selectedSubscription) {
            newSubscription = await subscriptionService.updateSubscription(selectedSubscription.id, course.id);
            console.log('newSubscription', newSubscription);
            // setSubscriptions(prev => prev.map(sub => sub.id == selectedSubscription.id ? newSubscription.subscription : sub));
        } else {
            newSubscription = await subscriptionService.addSubscription(course.id);
            console.log('newSubscription from new subscription', newSubscription);
            // setSubscriptions(prev => [...prev, newSubscription.subscription]);
        }
    }

    const handleOnSubscribed = (updated_subscription) => {
        if (subscriptions.some(sub => sub.subject_id == updated_subscription.subject_id)) {
            const subList = subscriptions.map(sub => sub.subject_id == updated_subscription.subject_id ? updated_subscription : sub);
            dispatch(updateStudentSubscriptions(subList));
        } else {
            dispatch(updateStudentSubscriptions([...subscriptions, updated_subscription]));
        }
        setEditing(null);
    }

    const handleAIToggle = async (subscriptionId, currentState) => {
        try {
            const updatedSubscription = await subscriptionService.toggleAICourse(subscriptionId, !currentState);
            // setSubscriptions(prev => prev.map(sub => 
            //     sub.id === subscriptionId ? updatedSubscription : sub
            // ));
        } catch (error) {
            console.error('Error toggling AI course:', error);
        }
    };

    if (isLoading) {
        return <Text>Loading...</Text>
    }

    return (
        <Flex direction="column" width="100%" align="center">
            <Box width="100%" maxWidth="1080px">
                <Flex direction="column" p="4" gap="4">
                    <Heading size="3" align="left">Subscriptions</Heading>
                    <Box>
                        <Flex direction="column" gap="2">
                            {subscriptions.map((subscription, index) => (
                                <Card
                                    key={subscription.id}
                                    p="3"
                                >
                                    <Flex direction="row" justify="start" align="center" gap="4">
                                        {subscription.course ? (
                                            <>
                                                <UserAvatar user={subscription.course?.teacher.user} size='5' />
                                                <Flex direction="column" align="start">
                                                    <Text weight="bold">{subscription.subject.name}</Text>
                                                    <Text size="2" color="gray">{`${subscription.course?.teacher.user.firstname} ${subscription.course?.teacher.user.lastname}`}</Text>
                                                    {/* <Text size="1" color="gray">{subscription.course.level.label}</Text> */}
                                                </Flex>
                                            </>
                                        ) : (
                                            <>
                                                <ExclamationTriangleIcon width="24px" height="24px" style={{ margin: 20 }} />
                                                <Flex direction="column" align="start">
                                                    <Text weight="bold">{subscription.subject.name}</Text>
                                                    <Button variant='ghost' onClick={() => { setEditing(subscription.subject.id) }}> <Pencil1Icon /> Setup Course</Button>
                                                </Flex>
                                            </>
                                        )}
                                        <Flex direction="column" ml="auto" justify="end" align="end" gap="4">
                                            {subscription.ai_course_id != null && (
                                                <Badge variant="soft" color="green"><CheckIcon/> AI</Badge>
                                            )}
                                        </Flex>
                                    </Flex>
                                </Card>
                            ))}

                            {availableSubjects.length > 0 && (
                                <Box>
                                    <Box p="3" style={{ border: '1px solid #ccc', borderRadius: '4px' }}>
                                        <Flex justify="between" align="center">
                                            <DropdownMenu.Root>
                                                <DropdownMenu.Trigger>
                                                    <Button color="green" variant="soft">
                                                        Add Subscription
                                                    </Button>
                                                </DropdownMenu.Trigger>
                                                <DropdownMenu.Content>
                                                    {availableSubjects.map((subject) => (
                                                        <DropdownMenu.Item
                                                            key={subject.id}
                                                            onClick={() => handleSelectSubject(subject.id)}
                                                        >
                                                            {subject.name}
                                                        </DropdownMenu.Item>
                                                    ))}
                                                </DropdownMenu.Content>
                                            </DropdownMenu.Root>
                                        </Flex>
                                        {/* {Object.keys(availableSubjectCourses).length > 0 && availableSubjectCourses.subscriptionId == null && (
                                            <Flex direction="row" gap="2" align="start" py="2">
                                                {availableSubjectCourses.courses.human_courses.map((course) => (
                                                    <CourseView 
                                                        key={course.id} 
                                                        course={course} 
                                                        selected={subscriptions.some(sub => sub.course.id == course.id)}
                                                        onSelect={handleSubscribe}
                                                    />
                                                ))}
                                                {availableSubjectCourses.courses.ai_courses.map((course) => (
                                                    <CourseView 
                                                        key={course.id} 
                                                        course={course} 
                                                        selected={subscriptions.some(sub => sub.course.id == course.id)}
                                                        onSelect={handleSubscribe}
                                                    />
                                                ))}
                                            </Flex>
                                        )} */}
                                    </Box>
                                </Box>
                            )}
                        </Flex>
                    </Box>
                </Flex>
            </Box>


            {/* dialog */}
            <Dialog.Root open={editing != null} onOpenChange={(boolean) => setEditing(boolean ? editing : null)}>

                <Dialog.Content maxWidth="450px">
                    <Dialog.Title>Edit Subscription</Dialog.Title>
                    <Dialog.Description size="2" mb="4">
                        <VisuallyHidden>Make changes to your subscription.</VisuallyHidden>
                    </Dialog.Description>

                    <Flex direction="column" gap="3">
                        <StudentCourseSetup editing={editing} onSubscribed={handleOnSubscribed} onCanceled={() => setEditing({ request: null, subscription: null })} />
                    </Flex>

                    <Flex gap="3" mt="4" justify="end">
                        <Dialog.Close>
                            <Button variant="soft" color="gray">
                                Cancel
                            </Button>
                        </Dialog.Close>
                        <Dialog.Close>
                            <Button>Save</Button>
                        </Dialog.Close>
                    </Flex>
                </Dialog.Content>
            </Dialog.Root>

        </Flex>
    );
};

export default StudentCourses;
